import React, { useState } from 'react';
import { Sidebar } from '../../sidebar';
import styled from 'styled-components';
import { CommonText } from '../../bumpViews/commonText';
import { ModalMobileTabs } from '../../listboardV2/modalMobileTab';
import { Button } from '../../button';
import { FaCheck, FaInfoCircle } from 'react-icons/fa';
import { DateRangePicker } from '../../form/date.range';
import { SelectAdv } from '../../form/select.adv';
import { OrderTypes, ServiceTypes } from '@lib/common';
import { Divider } from '../../divider';
const ExportDataStandardWrapper = styled.div `
  padding: 16px;
  display: flex;
  flex-direction: column;
  font-family: Inter; 
  font-size: 14px;
  font-style: normal;
  gap: 8px;
`;
const ExportHeader = styled.div `
  width: 100%;
  align-items: center;
  font-weight: 600;
  line-height: 20px;
  color: #0c202a;
`;
const DataRangeWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const DataRange = styled.div `
  display: flex;
  justify-content: space-between;
  padding: 8px 12px;
  border-radius: 4px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ selected }) => (selected ? '#FB2F2F' : '#4b4f5e')};
  background-color: ${({ selected }) => (selected ? '#FFF3F3' : '#f5f5f5')};
  border: 1px solid ${({ selected }) => (selected ? '#FB2F2F' : '#f5f5f5')};
  cursor: pointer;
`;
const EditButton = styled.div `
  width: 100%;
  border-radius: 4px;
  border: 1px solid #fb2f2f;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  margin-bottom: 16px;
`;
const CheckIcon = styled.div `
  margin-left: 8px;
`;
const ExportDataButton = styled.div `
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 8px 16px;
  align-items: center;
  background-color: #fff;
`;
const NoteWrapper = styled.div `
  display: flex;
  align-items: center;
  gap: 10px;
`;
const HEADER_HEIGHT = '56px';
const FOOTER_HEIGHT = '54px';
const SidebarBoderWrapper = styled.div `
  height: calc(100% - ${HEADER_HEIGHT} - ${FOOTER_HEIGHT});
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 5px;
    height: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #d9d9d9;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  .date-formgroup {
    width: 100%;
  }
`;
const TypeWrapper = styled.div `
  margin-bottom: 16px;
`;
const EditIcon = () => {
    return (React.createElement("svg", { width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M3.83334 12.6667H4.76667L10.5167 6.91666L9.58334 5.98333L3.83334 11.7333V12.6667ZM13.3667 5.95L10.5333 3.14999L11.4667 2.21666C11.7222 1.96111 12.0362 1.83333 12.4087 1.83333C12.7811 1.83333 13.0949 1.96111 13.35 2.21666L14.2833 3.14999C14.5389 3.40555 14.6722 3.71399 14.6833 4.07533C14.6944 4.43666 14.5722 4.74488 14.3167 4.99999L13.3667 5.95ZM3.16667 14C2.97778 14 2.81934 13.936 2.69134 13.808C2.56334 13.68 2.49956 13.5218 2.5 13.3333V11.45C2.5 11.3611 2.51667 11.2749 2.55 11.1913C2.58334 11.1078 2.63334 11.0329 2.7 10.9667L9.56667 4.1L12.4 6.93333L5.53334 13.8C5.46667 13.8667 5.39178 13.9167 5.30867 13.95C5.22556 13.9833 5.13934 14 5.05 14H3.16667ZM10.05 6.45L9.58334 5.98333L10.5167 6.91666L10.05 6.45Z", fill: "#FB2F2F" })));
};
export const ExportDataSidebar = ({ isOpen, handleClose, configExport, formats, token, restaurantId, handleOpenExportDataColumn }) => {
    const [tab, setTab] = useState(0);
    const [selectedRange, setSelectedRange] = useState(null);
    const [orderType, setOrderType] = useState(OrderTypes.All);
    const [serviceType, setServiceType] = useState(ServiceTypes.All);
    const [rangeDay, setRangeDay] = useState(0);
    const [start, setStart] = useState(0);
    const [end, setEnd] = useState(0);
    const [activeReportColumnModal, setActiveReportColumnModal] = useState(false);
    const handleTabChange = (selectedTab) => {
        setTab(selectedTab.value);
    };
    const handleOpenReportColumnModal = () => {
        setActiveReportColumnModal(true);
    };
    const handleCloseReportColumnModal = () => {
        setActiveReportColumnModal(false);
    };
    const getTimestampByDaysAgo = (daysAgo) => {
        const today = new Date();
        const timestamp = today.getTime() - daysAgo * 24 * 60 * 60 * 1000;
        return timestamp;
    };
    const handleRangeClick = (range) => {
        setSelectedRange(range);
        const today = new Date().getTime();
        if (range === 'Last 7 Days') {
            const startTimestamp = getTimestampByDaysAgo(7);
            setStart(startTimestamp);
            setEnd(today);
        }
        else if (range === 'Last 30 Days') {
            const startTimestamp = getTimestampByDaysAgo(30);
            setStart(startTimestamp);
            setEnd(today);
        }
        else if (range === 'Last 90 Days') {
            const startTimestamp = getTimestampByDaysAgo(90);
            setStart(startTimestamp);
            setEnd(today);
        }
    };
    const handleSelect = (type, timestamp) => {
        if (type === 'start') {
            setStart(timestamp);
        }
        else if (type === 'end') {
            if (start === -1) {
                alert('Please select an start time first');
                return;
            }
            const startDate = new Date(start).getTime();
            const endDate = new Date(timestamp).getTime();
            setRangeDay(Math.floor((endDate - startDate) / (24 * 60 * 60 * 1000)));
            if (rangeDay > 365) {
                alert('The time period must not exceed 365 days');
                return;
            }
            setEnd(timestamp);
        }
    };
    const getFormattedDate = (date, format) => {
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        if (format === 'DD/MM/YYYY') {
            return `${day}/${month}/${date.getFullYear()}`;
        }
        else {
            return `${month}/${day}/${date.getFullYear()}`;
        }
    };
    const renderDateRange = (range, days) => {
        if (selectedRange === range) {
            const endDate = new Date();
            const startDate = new Date();
            startDate.setDate(endDate.getDate() - days);
            const startFormatted = getFormattedDate(startDate, formats.date);
            const endFormatted = getFormattedDate(endDate, formats.date);
            return `Last ${days} days (${startFormatted} - ${endFormatted})`;
        }
        else {
            return range;
        }
    };
    const handleExportDataStandard = () => {
        if (rangeDay > 365) {
            alert('The time period must not exceed 365 days');
            return false;
        }
        else {
            if (tab === 0) {
                window.open(`${configExport.urls.api}/exports/dashboard/orders?jwt=${token}&rid=${restaurantId}&start=${start}&end=${end}`);
            }
            else {
                window.open(`${configExport.urls.api}/exports/dashboard/orders?jwt=${token}&rid=${restaurantId}&start=${start}&end=${end}`);
            }
        }
    };
    // const handleExportDataAdvanced = () => {
    //   const { columns } = orderExport;
    // 	const activeColumns: string[] = [];
    // 	Object.values(columns).forEach((c: any) => {
    // 		if (c.active) {
    // 			activeColumns.push(c.name);
    // 		}
    // 	});
    //   window.open(
    // 		`${configExport.urls.api}&start=${start}&end=${end}&columns=${activeColumns}&order_type=${orderType}&service_type=${serviceType}`
    // 	);
    // }
    return (React.createElement(React.Fragment, null,
        React.createElement(Sidebar, { isOpen: isOpen, headerTitle: "CSV Data Export", onClose: handleClose },
            React.createElement(SidebarBoderWrapper, null,
                React.createElement(ModalMobileTabs, { value: tab, onChange: handleTabChange, tabs: [
                        { label: 'Standard', value: 0 },
                        { label: 'Advanced', value: 1 },
                    ] }),
                tab === 0 && (React.createElement(ExportDataStandardWrapper, null,
                    React.createElement(ExportHeader, null, "Export Data Range"),
                    React.createElement(DataRangeWrapper, null,
                        React.createElement(DataRange, { selected: selectedRange === 'Last 7 Days', onClick: () => handleRangeClick('Last 7 Days') },
                            renderDateRange('Last 7 Days', 7),
                            selectedRange === 'Last 7 Days' && (React.createElement(CheckIcon, null,
                                React.createElement(FaCheck, null)))),
                        React.createElement(DataRange, { selected: selectedRange === 'Last 30 Days', onClick: () => handleRangeClick('Last 30 Days') },
                            renderDateRange('Last 30 Days', 30),
                            selectedRange === 'Last 30 Days' && (React.createElement(CheckIcon, null,
                                React.createElement(FaCheck, null)))),
                        React.createElement(DataRange, { selected: selectedRange === 'Last 90 Days', onClick: () => handleRangeClick('Last 90 Days') },
                            renderDateRange('Last 90 Days', 90),
                            selectedRange === 'Last 90 Days' && (React.createElement(CheckIcon, null,
                                React.createElement(FaCheck, null)))),
                        React.createElement(DataRange, { selected: selectedRange === 'Custom', onClick: () => handleRangeClick('Custom') },
                            "Custom",
                            selectedRange === 'Custom' && (React.createElement(CheckIcon, null,
                                React.createElement(FaCheck, null)))),
                        selectedRange === 'Custom' && (React.createElement("div", { style: { position: 'relative' } },
                            React.createElement(DateRangePicker, { formats: formats, timezone: formats.timezone, start: start, end: end, onSelect: handleSelect, isSidebar: true })))))),
                tab === 1 && (React.createElement(ExportDataStandardWrapper, null,
                    React.createElement(ExportHeader, null,
                        React.createElement(CommonText, { size: "semiMedium", weight: 600, color: "#0C202A" }, "Report Colums")),
                    React.createElement(CommonText, { size: "medium", weight: 400, color: "#6B7270" }, "You can customize the columns of your reports such like selecting which fields or data you want to include."),
                    React.createElement(EditButton, null,
                        React.createElement(EditIcon, null),
                        React.createElement(CommonText, { size: "semiMedium", weight: 600, lineHeight: "16px", color: "#FB2F2F", onClick: handleOpenExportDataColumn }, "Edit Report Columns")),
                    React.createElement(Divider, null),
                    React.createElement(TypeWrapper, null,
                        React.createElement(CommonText, { size: "semiMedium", weight: 500, color: "#4B4F5E" }, "Order Type"),
                        React.createElement(SelectAdv, { type: "single", options: [
                                {
                                    value: OrderTypes.All,
                                    label: 'All',
                                },
                                {
                                    value: OrderTypes.Now,
                                    label: 'Now',
                                },
                                {
                                    value: OrderTypes.Later,
                                    label: 'Laters',
                                },
                            ], value: orderType.toString(), onChange: (option) => {
                                setOrderType(option);
                            } })),
                    React.createElement(Divider, null),
                    React.createElement(TypeWrapper, null,
                        React.createElement(CommonText, { size: "semiMedium", weight: 500, color: "#4B4F5E" }, "Service Type"),
                        React.createElement(SelectAdv, { type: "single", options: [
                                {
                                    value: ServiceTypes.All,
                                    label: 'All',
                                },
                                {
                                    value: ServiceTypes.Pickup,
                                    label: 'Pickup',
                                },
                                {
                                    value: ServiceTypes.Delivery,
                                    label: 'Delivery',
                                },
                                {
                                    value: ServiceTypes.DineIn,
                                    label: 'Dine In',
                                },
                            ], value: serviceType.toString(), onChange: (option) => {
                                setServiceType(option);
                            } })),
                    React.createElement(Divider, null),
                    React.createElement(ExportHeader, null, "Export Data Range"),
                    React.createElement(DataRangeWrapper, null,
                        React.createElement(DataRange, { selected: selectedRange === 'Last 7 Days', onClick: () => handleRangeClick('Last 7 Days') },
                            renderDateRange('Last 7 Days', 7),
                            selectedRange === 'Last 7 Days' && (React.createElement(CheckIcon, null,
                                React.createElement(FaCheck, null)))),
                        React.createElement(DataRange, { selected: selectedRange === 'Last 30 Days', onClick: () => handleRangeClick('Last 30 Days') },
                            renderDateRange('Last 30 Days', 30),
                            selectedRange === 'Last 30 Days' && (React.createElement(CheckIcon, null,
                                React.createElement(FaCheck, null)))),
                        React.createElement(DataRange, { selected: selectedRange === 'Last 90 Days', onClick: () => handleRangeClick('Last 90 Days') },
                            renderDateRange('Last 90 Days', 90),
                            selectedRange === 'Last 90 Days' && (React.createElement(CheckIcon, null,
                                React.createElement(FaCheck, null)))),
                        React.createElement(DataRange, { selected: selectedRange === 'Custom', onClick: () => handleRangeClick('Custom') },
                            "Custom",
                            selectedRange === 'Custom' && (React.createElement(CheckIcon, null,
                                React.createElement(FaCheck, null)))),
                        selectedRange === 'Custom' && (React.createElement("div", { style: { position: 'relative' } },
                            React.createElement(DateRangePicker, { formats: formats, timezone: formats.timezone, start: start, end: end, onSelect: handleSelect, isSidebar: true })))))),
                React.createElement("div", { style: { padding: '16px' } },
                    React.createElement(NoteWrapper, null,
                        React.createElement("div", null,
                            React.createElement(FaInfoCircle, { color: "#FB2F2F", style: {
                                    width: '24px',
                                    height: '24px',
                                } })),
                        React.createElement(CommonText, { size: "medium", weight: 400, color: "#FB2F2F" }, "Note")),
                    React.createElement("div", { style: { color: '#6B7270', paddingTop: '16px' } },
                        React.createElement(CommonText, { size: "medium", weight: 400, color: "#6B7270" }, "You can export all your data into CSV format which can be used by Microsoft Excel and other softwares. Exporting may take a long time if you have a large amount of data. It can also place a large load on our servers so please do not abuse this feature.")))),
            React.createElement(ExportDataButton, null,
                React.createElement(Button, { full: true, color: "primary", type: "submit", onClick: handleExportDataStandard }, "Export Data")))));
};
//# sourceMappingURL=export-sidebar.js.map